// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"e01015318a430c208c87","293":"5c58dd59b0722dc97ca2"}[chunkId] + ".js";
};